import { Injectable } from '@angular/core';
import { MdSnackBar, MdSnackBarConfig } from '@angular/material';

@Injectable()
export class NotificationService {

	constructor(public snackBar: MdSnackBar) { }

	show(message) {
		let config = new MdSnackBarConfig();
		config.duration = 5000;
		this.snackBar.open(message, null, config);
	}
}



// WEBPACK FOOTER //
// ./src/app/shared/services/notification.service.ts